import React, { Fragment, useEffect, useState } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'

export default function DashBoard() {
   const [click, setClick] = useState(true)
   const location = useLocation()

   function addClick(e) {
      e.target.parentElement.classList.toggle("toggle_move_dashboard");
      setClick(!click)
   }

   // CLOSE sidebar automatically when the route changes
   useEffect(() => {
      // If sidebar is open, close it when navigation happens
      if (click) {
         const nav = document.querySelector('.nav_dashboard')
         if (nav && nav.classList.contains('toggle_move_dashboard')) {
            nav.classList.remove('toggle_move_dashboard')
         }
         setClick(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location.pathname]) // run whenever the path changes

   return (
      <Fragment>
         <div className='container-fluid position-relative pt-2 mt-5 dashBoard'>
            <div className="row">

               <div className='nav_dashboard bg-body-tertiary position-fixed'>
                  {click ?
                     <button onClick={(e) => { addClick(e) }} className='btn btn-new-color btn-sm position-absolute btn_Control'>Exist</button>
                     :
                     <button onClick={(e) => { addClick(e) }} className='btn btn-new-color btn-sm position-absolute btn_Control'>Control</button>
                  }

                  <h1 className="h6 text-center my-1 border-2 border-bottom py-2">Dashboard</h1>

                  <div className='p-2'>
                     <ul className="links">
                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-folder-open main-color"></i></span>
                           <Link className="text-body-secondary" to="orderDashboard">Order <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-users main-color"></i></span>
                           <Link className="text-body-secondary" to="userDashboard">User <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-list main-color"></i></span>
                           <Link className="text-body-secondary" to="companyDashboard">Company <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-code-branch main-color"></i></span>
                           <Link className="text-body-secondary" to="BranchDashboard">Branch <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-flask-vial main-color"></i></span>
                           <Link className="text-body-secondary" to="testDashboard">Test <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-bed main-color"></i></span>
                           <Link className="text-body-secondary" to="patientDashboard">Patients <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-copy main-color"></i></span>
                           <Link className="text-body-secondary" to="reportDashboard">Reports <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-comments main-color"></i></span>
                           <Link className="text-body-secondary" to="PrescriptionDashboard">Prescription <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-comments main-color"></i></span>
                           <Link className="text-body-secondary" to="ProfileDashboard">Profiles <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-bell main-color"></i></span>
                           <Link className="text-body-secondary" to="/dashBoard">Notification <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>

                        <li className="bg-white fw-bold position-relative">
                           <span className="m-2"><i className="fa-solid fa-gear main-color"></i></span>
                           <Link className="text-body-secondary" to="Setting">Setting <span className="arrow position-absolute"><i className="fa-solid fa-chevron-right"></i></span></Link>
                        </li>
                     </ul>
                  </div>
               </div>

               <div className="col-md-12">
                  <Outlet></Outlet>
               </div>

            </div>
         </div>
      </Fragment>
   )
}
